<template>
    <div class="fx-g1 fx-col" v-loading="loading" element-loading-text="数据拼命加载中...">
        <div class="fx-g1 fx-col panel_body">
            <div v-for="codeBase in codeBases" :key="codeBase.id" >
                <div class="item_block fx">
                    <!--左侧内容 -->
                    <div class="fx-col" style="width:1500px;position: relative">
                        <div class="fx fx-c_center info_row" >
                            <div class="coverimg" v-if="codeBase.type == 1"  style="width: 250px; height: 150px">
                                <el-image
                                    style="width: 100%;height: 92%"
                                    :src="codeBase.codes[0] ? codeBase.codes[0].coverImg : ''"
                                    :lazy="true"
                                    fit="contain"></el-image>
                            </div>
                            <div class="coverimg" v-if="codeBase.type == 2"  style="width: 250px; height: 150px">
                                <el-image
                                    style="width: 100%;height: 92%"
                                    src="http://assets.program.leadersir.cn/imgs/python_logo.jpeg"
                                    :lazy="true"
                                    preview-src-list="['http://assets.program.leadersir.cn/imgs/python_logo.jpeg']"
                                    fit="contain"></el-image>
                            </div>
                            <div class="fx-g1 mr-50">
                                <div class="lesson_name "><!-- fx fx-m_between fx-c_center -->
                                    {{codeBase.title}}

                                </div>
                                <div class="mt-10">分享人：{{codeBase.operatorName}}</div>
                                <div class="mt-10">{{codeBase.content}}</div>
                                <div class="grid col-4 lesson_resource font12" style="margin-top: 12px">
                                    <!-- v-if="codeBase.codes.length!=0" -->
                                    <span  class="fx fx-c_center">代码:
                                    <el-link type="primary" @click="viewCode(codeBase.type, codeBase.codes[0].id)" :underline="false" class="font12"><i class="iconfont icon-word"></i>查看</el-link>
                                </span>
                                </div>
                                <div style="margin-top: 12px">
                                    <tag-group :tags="codeBase.tagArray" size="mini" style="justify-content: flex-start"></tag-group>
                                </div>
                                <div v-if="!codeBase.hasUser">
                                    <el-button @click="addMyCodeBases(codeBase)" type="primary" style="margin-top: 10px;border-radius: 10px;">
                                        <i class="el-icon-plus font15" style="fond"></i>
                                        加到我的代码库
                                    </el-button>
                                </div>
                            </div>
                        </div>
                        <!--点赞标记-->
                        <div class="favor_flag" @click="toggleFavor(codeBase)">
                            <div class="flag fx-col fx-c_center pointer">
                                <i class="iconfont icon-like-fill font24 mt-10"
                                   :class="{'text_white':!codeBase.hasFavor,'active':codeBase.hasFavor}"></i>
                                <span class="text_white">{{ codeBase.favorCount }}</span>
                            </div>
                        </div>
                    </div>
                </div>


                <!--右侧评论 -->
                <div class="item_block fx">
                    <div class="fx-g1 ml-40 comment_panel fx-col">
                        <div class="fx noshrink">
                            <div class="fx-g1 comment_input fx fx-c_center">
                                <span v-if="codeBase.comment.toUserId" class="text_primary mr-5">@{{codeBase.comment.toUserName}}</span>
                                <input @keydown.delete="checkContent(codeBase)" v-model="codeBase.comment.content" type="text" class="fx-g1" placeholder="说点什么....">
                            </div>
                            <el-button @click="doComment(codeBase)" type="primary">评论</el-button>
                        </div>
                    </div>
                </div>
                <div  class="item_block " style="padding-left: 77px;padding-right: 77px;position: relative;top: -16px;">
                    <div class="">
                        <div v-for="msg in codeBase.msgs" :key="msg.id" class="fx mt-15 pointer msg_item"  style="border-bottom: 1px solid var(--border)">
                            <img :src="msg.fromUserAvatar" class="avatar noshrink">
                            <div class="msg_content fx-g1 ml-10 mr-10">{{msg.fromUserName}}：
                                <span v-if="msg.toUserId" class="text_primary">@{{msg.toUserName}}</span>
                                {{msg.content}}
                                <span @click="toReply(codeBase,msg)" class="reply_btn text_primary" v-if="msg.currentUserId != msg.fromUserId">回复</span>
                                <el-popconfirm @onConfirm="todel(msg)" v-if="msg.currentUserId == msg.fromUserId" title="确认删除该评论吗？" >
                                    <el-link  class="del_btn text_primary" slot="reference"  :underline="false"><i class="iconfont icon-shanchu"></i>删除
                                    </el-link>
                                </el-popconfirm>
                            </div>
                            <span class="msg_time noshrink text_light font12">{{msg.createTime}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="panel_foot fx fx-m_end fx-c_center">
            <el-pagination
                :background="true"
                prev-text="上一页"
                next-text="下一页"
                layout="prev, pager, next"
                :current-page="pager.currentPage"
                :page-size="pager.pageSize"
                :total="pager.dataTotal"
                @current-change="pageChange"
            >
            </el-pagination>
        </div>
        <ResourceDrawer :showBox="showResources" @play="play"
                        @close="showResources=false" label="资源列表" :resources="currentResources"></ResourceDrawer>
        <VideoDrawer v-if="showVideo" @close="showVideo=false" :url="currentVideo"></VideoDrawer>

    </div>
</template>

<style scoped>
    .panel_foot  {
        background-color: white;
    }
    .reply_btn{
        display: none;
    }
    .msg_item:hover .reply_btn{
        display: inline-block;
    }
    .del_btn{
        display: none;
    }
    .msg_item:hover .del_btn{
        display: inline-block;
    }
    .msg_content{
        padding-top: 3px;
        line-height: 24px;
    }
    .msg_time{
        line-height: 30px;
    }
    .avatar {
        width: 30px;
        height: 30px;
    }
    .comment_input {
        background: white;
        height: 40px;
        padding: 0 20px;
        margin-right: 10px;
        border-radius: 8px;
    }
    .comment_input input {
        border: none;
        height: 100%;

    }
    .comment_input input:focus{
        outline: none;
    }
    .comment_panel {
        background: #f4f4f4;
        padding: 10px 10px 10px 20px;
        border-radius: 10px;
        max-height: 280px;
    }
    .favor_flag{
        filter: drop-shadow(2px 4px 3px rgba(50, 50, 0, 0.5));
        position: absolute;
        right: 0;
        top: -18px;
    }
    .flag {
        width: 70px;
        height: 106px;
        background: #419ffd;
        clip-path: polygon(0% 0%,0% 100%,50% 60%,100% 100%,100% 0);
        box-shadow: 0 2px 8px rgba(0,0,0,.12);
    }
    .flag .iconfont.active{
        color: #f6fa16;
    }
    .el-form-item {
        margin-bottom: 10px;
    }
    .tip {
        padding:0 6px 0 12px;
    }
    .item_block {
        background: white;
        padding: 18px 20px 18px 40px;
        border-radius: 6px;
        margin-bottom: 10px;
    }
    .info_row>*:not(:first-child) {
        margin-left: 20px;
    }

    .coverimg {
        width: 170px;
        height: 125px;
    }
    .lesson_name {
        font-size: 16px;
        font-weight: bold;
        color: var(--dark);
    }
    .lesson_resource i.iconfont, .task_info i.iconfont {
        vertical-align: text-bottom;
    }

    .task_item {
        height: 50px;
        border-bottom: 1px solid var(--border);
    }
</style>
<style>

</style>

<script>
    import ResourceDrawer from '@/components/ResourceDrawer';
    import VideoDrawer from '@/components/VideoDrawer';
    export default {
        components: {
            ResourceDrawer,
            VideoDrawer,
        },
        props: [
            "attr"
        ],
        data() {
            return {
                form:{
                    keywords:"",
                    knowledgeIds:[],
                    userId:"",
                    linkId:this.attr == undefined ? '' : this.attr.id
                },
                loading: true,
                showResources: false,
                currentResources: [],
                showVideo: false,
                currentVideo: null,

                options:[],
                codeBases: [],
                currentCodeBases:[],
                userOption:[],
                pager: {
                    pageSize: 12,
                    dataTotal: 0,
                    currentPage: 1
                },
            }

        },

        watch: {
            "form": {
                handler: function () {
                    this.form.linkId = 0;
                    //查询条件变了
                    this.loadCodeBases();
                },
                deep: true
            }
        },

        methods: {
            /**
             * 切换对这节课的点赞
             * @param codeBase
             */
            toggleFavor(codeBase) {
                let hasFavor = codeBase.hasFavor//当前是否是已点赞
                hasFavor = !hasFavor;
                this.$ajaxPost("/codeBase/toggleFavorCount", {
                    id: codeBase.id,hasFavor: hasFavor
                }, (data) => {
                    codeBase.hasFavor = hasFavor;
                    codeBase.favorCount += (hasFavor ? 1 : -1); //这个数不用特意发请求去读取最新值，只要保证数据库里的数准确就行
                })

            },
            /**
             * 点了评论按钮
             * @param codeBase
             */
            doComment(codeBase) {
                let comment = codeBase.comment;
                //TODO 发请求，去保存
                //保存后，应该返回保存的msg 记录
                //然后插入到 codeBase.msgs 数组的开头
                this.$ajaxPost("/leaveMessage/addMsgByCodeBase", {
                    leaveMessage: {...comment,linkId:codeBase.id}
                }, (data) => {
                    this.codeBases.forEach((item, i) => {
                        if (item.id == codeBase.id) {
                            this.codeBases[i].msgs.unshift(data.result);
                            return;
                        }
                    })
                    codeBase.comment.content = ''
                    codeBase.comment.toUserId = 0;
                    codeBase.comment.toUserName = '';
                })
            },
            /**
             * 按下删除键的时候，如果内容已经为空了，并且前面有@的人，那么就清空@的人
             * @param codeBase
             */
            checkContent(codeBase) {
                if (codeBase.comment.content == '') {
                    codeBase.comment.toUserId = 0;
                    codeBase.comment.toUserName = '';
                }
            },
            /**
             * 指定一个用户进行回复
             * @param codeBase
             * @param msg
             */
            toReply(codeBase, msg) {
                codeBase.comment.id = msg.id;
                codeBase.comment.toUserId = msg.fromUserId;
                codeBase.comment.toUserName = msg.fromUserName;
            },
            todel(msg) {
                this.$ajaxGet("/leaveMessage/del/"+msg.id, (data) => {
                    this.$showSuccess("操作成功");
                    this.loadCodeBases();
                })
            },
            //加载单节课
            loadCodeBase(codeBase) {
                codeBase.codes = codeBase.resources.filter(r => r.category == 4);
                codeBase.tasks = [];
                let index = -1;

                this.codeBases.forEach((item, i) => {
                    if (item.id == codeBase.id) {
                        index = i;
                        codeBase.tasks = item.tasks;
                        return;
                    }
                })
                if (index == -1) {
                    this.codeBases.push(codeBase);
                } else {
                    this.$set(this.codeBases, index,  codeBase);
                }
            },
            //加载所有课
            loadCodeBases() {
                this.$ajaxPost("/codeBase/listBySharing",{form : this.form,pager: {...this.pager, dataTotal: 0}}, (data) => {
                    let codeBases = data.result;
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    codeBases.forEach(item => {
                        item.codes = item.resources.filter(r => r.category == 4);
                        item.tasks = null;
                        item.msgs = [];

                        item.comment = {
                            id:0,
                            toUserId: 0, //存储该节课聊天@的人
                            toUserName:'',
                            content:'', //存储聊天输入框内容
                        }

                    })
                    this.codeBases = codeBases;

                    if (codeBases.length == 0) {
                        this.loading = false;
                    } else {
                        var codeBasess = codeBases.map(item => item.id);
                        this.currentCodeBases = codeBasess;
                        this.loadMsgs(codeBasess);
                        this.loading = false;
                    }

                })
            },
            pageChange(page) {
                this.pager.currentPage = page;
                this.loadMsgs(this.currentCodeBases);
            },
            /**
             * 加载课程的聊天记录
             * @param codeBaseIds
             */
            loadMsgs(codeBaseIds) {
                //模拟读取数据，应该按照 id，倒序显示，也就是最新的消息在上面显示
                // 而且后台应该根据id数组，一次性把这些课程的所有的聊天记录都读出来，不要每节课发一个请求
                this.$ajaxPost("/leaveMessage/listCodeBaseByPager", {
                    ids: codeBaseIds,pager: {...this.pager, dataTotal: 0}
                }, (data) => {
                    let {offset, ...pager} = data.pager;
                    this.pager = pager;
                    data.result.forEach((item, i) => {
                        this.codeBases[i].msgs = item
                    })
                })
            },

            addMyCodeBases(item) {
                this.$ajaxGet("/codeBase/addMyCodeBaseById/"+item.id, (data) => {
                    this.$showSuccess("添加成功");
                })
            },
            setShowResources(resources) {
                this.currentResources = resources;
                this.showResources = true;
            },
            play(url) {
                this.currentVideo = url;
                this.showVideo = true;
            },
            viewCode(codeBaseType, id) {
                this.$goEditCode(codeBaseType, `mode=caseview&id=${id}`);
            },
            handleChange(value) {
                console.log(value);
            },
            loadFuncs() {
                let datas = {"type": ''};
                this.$ajaxPost("/knowledge/knowledgeByTask",{form:datas} , (data) => {//knowledgeTree
                    this.options = data.result;
                })
            },
            loadUserOption() {
                 this.$ajaxPost(`/user/list`,{form:{classId:0},isstaff:true}, data => {
                    this.userOption = data.result;
                })
            },
        },
        created() {
            this.loadCodeBases();
            this.loadFuncs();
            this.loadUserOption();
        }

    }
</script>
